import { render, staticRenderFns } from "./editContractTypeSpec.vue?vue&type=template&id=4f837668"
import script from "./editContractTypeSpec.vue?vue&type=script&lang=js"
export * from "./editContractTypeSpec.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports